<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  prefix?: string
  name: string
  color?: string
  variant?: 'v1' | 'v2'
}>()

// default prefix and variant
const prefix = props.prefix ?? 'icon'
const variant = props.variant ?? 'v1'

// compute class name (icon or iconV2)
const iconClass = computed(() => (variant === 'v2' ? 'iconV2' : 'icon'))

// inline style for color if provided
const inlineStyle = computed(() => (props.color ? { color: props.color } : undefined))
</script>

<template>
  <svg
    :class="iconClass"
    :style="inlineStyle"
    aria-hidden="true"
  >
    <use :href="`#${prefix}-${props.name}`" />
  </svg>
</template>

<style lang="scss" scoped>
/* Shared base rules for both variants */
.icon,
.icon > svg{
  fill: currentColor;
  display: inline-block;
  width: 1em;
  min-width: 1em;
  height: 1em;
  min-height: 1em;
  line-height: 1;
}

/* Variant-specific visual tweaks for iconV2 can be added below */


.mineture-tidtiltur-dk {
  .icon,
  .icon > svg {
    fill: $dn-blue;
    color: $dn-black;
  }
}

.events-naturensuge-dk {
  .icon,
  .icon > svg{
    fill: $dn-white;
    color: $dn-naturensuge-let;
  }
}

/* Preview brand: keep circular style for V1, and a slightly different padding for V2 if desired */
.mineindsamlinger-affaldsindsamlingen-dk,
.events-affaldsindsamlingen-dk,
.lokaleevents-dn-dk,
.arrangementer-dn-dk {
  .icon {
    fill: currentColor;
    display: inline-block;
    width: 1em;
    min-width: 1em;
    height: 1em;
    min-height: 1em;
    line-height: 1;
  }

  /* V2 variant: optionally smaller circle and different spacing */
  .iconV2 {
    border: 1px solid $dn-v2-dark-green;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    padding: 6px;
    margin-top: auto;
    transition: transform .4s ease;
    transform-origin: left;
  }


  a:hover .iconV2 {
    transform: translate(.225rem);
  }
}
</style>
